import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { BarChart3, Eye, Loader2, CalendarClock, Wine, Utensils } from "lucide-react";

const iconFor = (m) => (m.is_daily ? CalendarClock : m.type === "bevande" ? Wine : Utensils);

const AnalyticsPage = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/analytics/menus").then((r) => setData(r.data)).catch(() => setData({ total: 0, menus: [] }));
  }, []);

  if (!data) return <p className="text-muted-foreground flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Caricamento…</p>;

  const menus = [...(data.menus || [])].sort((a, b) => b.views - a.views);
  const max = Math.max(1, ...menus.map((m) => m.views));

  return (
    <div className="space-y-8" data-testid="analytics-page">
      <div>
        <h1 className="font-cabinet font-bold text-3xl tracking-tight">Statistiche</h1>
        <p className="text-muted-foreground text-sm mt-1">Numero di visualizzazioni di ciascun menù da parte dei clienti.</p>
      </div>

      <div className="bg-white rounded-2xl border border-border p-6 flex items-center gap-4" data-testid="analytics-total">
        <span className="w-12 h-12 rounded-xl bg-[#002FA7]/10 text-[#002FA7] flex items-center justify-center">
          <Eye className="w-6 h-6" />
        </span>
        <div>
          <p className="text-3xl font-bold leading-none" data-testid="analytics-total-count">{data.total}</p>
          <p className="text-muted-foreground text-sm mt-1">Visualizzazioni totali</p>
        </div>
      </div>

      <section className="bg-white rounded-2xl border border-border p-6">
        <h2 className="font-cabinet font-semibold text-lg mb-4 flex items-center gap-2"><BarChart3 className="w-5 h-5 text-[#002FA7]" /> Per menù</h2>
        {menus.length === 0 ? (
          <p className="text-muted-foreground text-sm">Nessun menù disponibile.</p>
        ) : (
          <div className="space-y-4">
            {menus.map((m) => {
              const Icon = iconFor(m);
              const pct = Math.round((m.views / max) * 100);
              return (
                <div key={m.id} data-testid={`analytics-menu-${m.id}`}>
                  <div className="flex items-center justify-between gap-3 mb-1.5">
                    <span className="flex items-center gap-2 text-sm font-medium min-w-0">
                      <Icon className="w-4 h-4 text-[#002FA7] flex-shrink-0" />
                      <span className="truncate">{m.name}</span>
                    </span>
                    <span className="text-sm font-semibold tabular-nums" data-testid={`analytics-views-${m.id}`}>{m.views}</span>
                  </div>
                  <div className="h-2.5 rounded-full bg-muted overflow-hidden">
                    <div className="h-full rounded-full bg-[#002FA7] transition-all duration-500" style={{ width: `${pct}%` }} />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
};

export default AnalyticsPage;
